/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  position: relative;
  display: inline-flex;
}

:host([scale=s]) {
  block-size: 1.25rem;
  inline-size: 1.25rem;
}

:host([scale=m]) {
  block-size: 1.5rem;
  inline-size: 1.5rem;
}

:host([scale=l]) {
  block-size: 2rem;
  inline-size: 2rem;
}

.swatch {
  overflow: hidden;
  block-size: inherit;
  inline-size: inherit;
}
.swatch rect {
  transition-property: all;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.swatch--no-color rect {
  fill: var(--calcite-color-foreground-1);
}
.swatch--no-color line {
  stroke: var(--calcite-color-status-danger);
}

.checker {
  fill: #cacaca;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}